import styled from 'styled-components';

import { overflowHandler, sizerStyleHandler } from './handlers';
import { VirtualDirection, VirtualDirectionProps, VirtualSizerElementProps } from './types';
import { getStyle } from './utils';

const getOverflowValue = getStyle<VirtualDirectionProps>(overflowHandler, 'direction');
const getSizerStyle = getStyle<VirtualSizerElementProps>(sizerStyleHandler, 'direction', 'scrollableSize');

export const VirtualContainerElement = styled.div`
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
`;

export const VirtualScrollContainerElement = styled.div<VirtualDirectionProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    -webkit-overflow-scrolling: touch;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    ${getOverflowValue}
`;

export const VirtualSizerElement = styled.div<VirtualSizerElementProps>`
    ${getSizerStyle}
`;

export const VirtualViewportElement = styled.div<VirtualDirectionProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${(props) => (props.direction === VirtualDirection.Horizontal ? 'row' : 'column')};
`;
